export const Questions = [
    {
        prompt:"Which of this is not a programming language?",
        optionA:"Python",
        optionB:"JavaScript",
        optionC:"MC-03",
        optionD:"Java",
        answer:"optionC",
    },
    {
        prompt:" Which of the following type of class allows only one object of it to be created?",
        optionA:"Virtual class",
        optionB:"Abstract class",
        optionC:"Singleton class",
        optionD:"Friend class",
        answer:"optionC",
    },
    {
        prompt:"Which of the following is not a type of constructor?",
        optionA:"Copy constructor",
        optionB:"Friend constructor",
        optionC:"Default constructor",
        optionD:"Parameterized constructor",
        answer:"optionB"
    },
    {
        prompt:"Which of the following statements is correct?",
        optionA:"Base class pointer cannot point to derived class.",
        optionB:"Derived class pointer cannot point to base class.",
        optionC:"Pointer to derived class cannot be created.",
        optionD:"Pointer to base class cannot be created.",
        answer:"optionB", 
    },
    {   
        prompt:"Which of the following is not the member of class?",
        optionA:"Static function",
        optionB:"Friend function",
        optionC:"Const function",
        optionD:"Virtual function",
        answer:"optionB", 
    },
    {
        prompt:"Which of the following concepts means determining at runtime what method to invoke?",
        optionA:"Data hiding",
        optionB:"Dynamic Typing",
        optionC:"Dynamic binding",
        optionD:"Dynamic loading",
        answer:"optionC", 
    },
    {
        prompt:"Which of the following term is used for a function defined inside a class?",
        optionA:"Member Variable",
        optionB:"Member function",
        optionC:"Class function",
        optionD:"Classic function",
        answer:"optionB", 
    },
    {
        prompt:"Which of the following concept of oops allows compiler to insert arguments in a function call if it is not specified?",
        optionA:"Call by value",
        optionB:"Call by reference",
        optionC:"Default arguments",
        optionD:"Call by pointer",
        answer:"optionC", 
    },
    {
        prompt:"How many instances of an abstract class can be created?",
        optionA:"1",
        optionB:"5",
        optionC:"13",
        optionD:"0",
        answer:"optionD", 
    },
    {
        prompt:"Which of the following concepts of OOPS means exposing only necessary information to client?",
        optionA:"Encapsulation",
        optionB:"Abstraction",
        optionC:"Data hiding",
        optionD:"Data binding",
        answer:"optionC", 
    },

  

];